const B = /[A-Z0-9-]/i
const R = /[АВЕКМНОРСТУХ]/i
const V = /[A-HJ-NPR-Z0-9]/i

export default {
  tel: '+7 (###) ###-####',
  drivingLicenceSer: [
    /\d/,
    /\d/,
    ' ',
    /[0-9A-Za-zА-Яа-я]/,
    /[0-9A-Za-zА-Яа-я]/,
  ],
  enginePower(val: string) {
    let limit = 4
    let flag = true
    return val.split('').reduce(
      (accum, it, i) => {
        if (limit >= i && i) accum[i] = /\d/
        if (i && flag && /[.,]/.test(it)) {
          // @ts-ignore
          accum[i] = it
          limit = i + 1
          flag = false
        }
        return accum
      },
      [/\d/]
    )
  },
  registrationPlate: [R, /\d/, /\d/, /\d/, R, R, ' ', /\d/, /\d/, /\d/],
  vinCode: [V, V, V, V, V, V, V, V, V, V, V, V, V, V, V, V, V],
  passportSeriesNumber: /\d{4} \d{6}/,
  bodyNumber: [
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
    B,
  ],
  broker(val: string) {
    if (/^\d{2}\\/.test(val)) {
      return [
        /\d/,
        /\d/,
        /\\/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /[А-Яа-яЁё]/,
      ].slice(0, val.length)
    }
    return [
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ]
  },
}
